import { Ref, forwardRef } from "react"

import { faIcon } from "@utils/faIcon"

import { IconButton, Tooltip } from "@atoms"

import { AddFilterButtonProps } from "./AddFilterButton.types"

const ADD_FILTER_LABEL = "Add filter"

function AddFilterButton(props: AddFilterButtonProps, ref: Ref<HTMLButtonElement>) {
    const { noDebounce = true, ...rest } = props

    return (
        <Tooltip body={ADD_FILTER_LABEL} wrapChildren={false}>
            <IconButton
                ref={ref}
                size="lg"
                variant="ghost"
                icon={faIcon({ name: "plus", style: "regular" })}
                aria-label={ADD_FILTER_LABEL}
                noDebounce={noDebounce}
                {...rest}
            />
        </Tooltip>
    )
}

export default forwardRef(AddFilterButton)
